import React from 'react';
import Type from 'prop-types';
import { noop } from 'lodash';
import cn from 'classnames';
import styles from './Image.module.css';

const Image = ({ sourceSet, source, className, ...other }) => {
  const finalSourceSet = sourceSet
    ? sourceSet.map(({ source: subSource, descriptor }) => `${subSource} ${descriptor}`).join(',')
    : null;

  return finalSourceSet ? (
    // eslint-disable-next-line jsx-a11y/alt-text
    <img src={source} srcSet={finalSourceSet} className={cn(styles.img, className)} {...other} />
  ) : (
    // eslint-disable-next-line jsx-a11y/alt-text
    <img src={source} className={cn(styles.img, className)} {...other} />
  );
};

Image.propTypes = {
  alt: Type.string.isRequired,
  source: Type.string.isRequired,
  sourceSet: Type.arrayOf(
    Type.shape({
      source: Type.string.isRequired,
      descriptor: Type.string,
    }),
  ),
  className: Type.string,
  onLoad: Type.func,
  onError: Type.func,
};

Image.defaultProps = {
  sourceSet: null,
  className: '',
  onLoad: noop,
  onError: noop,
};

export default Image;
